<template>
  <div>
    <div class="row">
      <div class="col-xl-5 col-lg-4">
        <card v-loading="loading" :title="$t('municipalities.pageSingle.title')">
          <div class="author">
            <div class="block block-one"></div>
            <!--        <div class="block block-two"></div>-->
            <div class="block block-three"></div>
            <div class="block block-four"></div>
          </div>
          <span v-if="error">{{ JSON.stringify(error) }}</span>
          <span v-else>
            <municipality-details v-if="this.details !== null" :details="details"/>
          </span>
        </card>
      </div>
      <div class="col-12">
        <card>
          <municipality-bot-clients-page :municipality-id="$route.params.id"/>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import MunicipalityDetails from "src/components/Municipality/MunicipalityDetails";
import {mapActions, mapState} from "vuex";
import MunicipalityBotClientsPage from "@/pages/Municipalities/MunicipalityBotClients.vue";

export default {
  name: 'MunicipalityPage',
  components: {
    MunicipalityBotClientsPage,
    MunicipalityDetails
  },
  methods: {
    ...mapActions(['LoadMunicipality'])
  },
  computed: {
    ...mapState({
      loading: state => state.municipality.loading,
      details: state => state.municipality.data,
      error: state => state.municipality.error,
    }),
  },
  mounted() {
    if (this.details === null || this.details.id != this.$route.params.id) {
      this.LoadMunicipality({id: this.$route.params.id})
    }
  }
};
</script>
<style>
</style>
